import WebHttpClient from '~src/httpClient/WebHttpClient';
import {
  GetSiteEncryptionKeyHistoryRequest,
  IGetSiteEncryptionKeyHistoryResult
} from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyHistoryRequest';

export function getSiteEncryptionKeyHistory(): Promise<IGetSiteEncryptionKeyHistoryResult>  {
  return WebHttpClient.sendRequest(new GetSiteEncryptionKeyHistoryRequest({}));
}

export const GetSiteEncryptionKeyHistoryService = {
  getSiteEncryptionKeyHistory: getSiteEncryptionKeyHistory
};
